var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { id: _vm.modalId, "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg modal-dialog-scrollable",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "row w-100 no-gutters" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h4", { staticClass: "modal-title" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("History")) +
                        "\n                        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c(
                        "label",
                        {
                          staticClass: "input-group-text",
                          attrs: { for: "inputGroupSelect01" }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("kanbanDays")) +
                              "\n                                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.state.historyDays,
                          expression: "state.historyDays",
                          modifiers: { number: true }
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        min: "1",
                        max: "100",
                        placeholder: ""
                      },
                      domProps: { value: _vm.state.historyDays },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.reload.apply(null, arguments)
                        },
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.state,
                            "historyDays",
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-primary",
                          attrs: { type: "button" },
                          on: { click: _vm.reload }
                        },
                        [_c("i", { staticClass: "fas fa-arrow-right" })]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-toggle": "modal",
                        "data-target": "#" + _vm.modalId
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.close.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                            ×\n                        "
                      )
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c("vue-good-table", {
                  attrs: {
                    columns: _vm.columnsConfig,
                    rows: _vm.sortedEvents,
                    "search-options": {
                      enabled: true,
                      placeholder: _vm.$t("txtSearch")
                    },
                    "pagination-options": {
                      enabled: true,
                      nextLabel: _vm.$t("txtNext"),
                      prevLabel: _vm.$t("txtPrev"),
                      rowsPerPageLabel: _vm.$t("txtPagePer"),
                      ofLabel: _vm.$t("txtOf"),
                      pageLabel: _vm.$t("txtPage"),
                      allLabel: _vm.$t("txtAll")
                    }
                  },
                  on: { "on-row-click": _vm.onRowClick }
                })
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }